export default "__VITE_ASSET__217d394c__"